/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from "classnames";
import { produce } from "immer";
import styled from "styled-components";

import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { getImageContentById } from "@helpers/general";

import { Nutriscore } from "@components/OrderTaking/common/Nutriscore";
import ClosecircleIcon from "@components/OrderTaking/Components/Icons/ClosecircleIcon";
import { InfoIcon } from "@components/OrderTaking/Components/Icons/InfoIcon";
import { cancelModifyProduct } from "@components/OrderTaking/Helpers";
import {
    deleteAbortedNewItem,
    deleteWorkFlowStepShopCart,
    removeLastWorkflow,
    restoreItemComposition,
    SelectProduct,
    setAdditionalItems,
    setIsModification,
} from "@components/OrderTaking/Store/feature";

const StyledDiv = styled.div`
    margin-left: auto;
    padding: 10px;
    z-index: 999;
`;
type InfoCloseProductType = {
    product: ProductType;
    workflowData: any;
    currentWorkflow: any;
    onClose: any;
    handleNutritionalInformationDialogOnCloseEvent: () => void;
};
export function InfoCloseProduct({
    product,
    workflowData,
    currentWorkflow,
    onClose,
    handleNutritionalInformationDialogOnCloseEvent,
}: InfoCloseProductType): JSX.Element {
    const dispatch = useDispatch();
    const {
        isClosingButtonActive,
        closingButtonContent,
        isProductInfoIconActive,
        productInfoIconId,
        isNutriscoreInCompositeProductActive,
    } = useSelector(
        (state) => (state as any).settingSlice.compositeProductSettings,
        shallowEqual
    );
    const menuProduct = useSelector(
        (state) => (state as any).ProductSlice.product
    );

    const orderWorkflowItemSlice = useSelector(
        (state) => (state as any).orderWorkflowItemSlice,
        shallowEqual
    );

    const isModification = useSelector(
        (state) => (state as any).orderWorkflowItemSlice.isModification,
        shallowEqual
    );
    const styles = { height: "70%", width: "80%" };
    const imageSrc = React.useMemo(() => {
        return getImageContentById(closingButtonContent);
    }, []);
    const InfoImageSrc = React.useMemo(() => {
        return getImageContentById(productInfoIconId);
    }, []);

    const OnClickClose = () => {
        const copyWorkflow: any = produce(
            workflowData,
            (draftWorkflowData: any) => draftWorkflowData
        );
        const workflow = [...workflowData];
        workflow && workflow.pop();

        let oldComposition = {};

        if (isModification || orderWorkflowItemSlice.isInternalModification) {
            const path =
                workflow.length > 1
                    ? workflow[workflow.length - 1]?.workflow[
                          workflow[workflow.length - 1].index
                      ].path
                    : currentWorkflow?.workflow[currentWorkflow.index].path;

            const newpath = path.map((elm: any) => {
                return elm?.name !== undefined ? elm.name : elm;
            });

            const MenuPath = newpath.slice(0, -1);

            oldComposition = cancelModifyProduct(
                MenuPath,
                orderWorkflowItemSlice.productBeforeUpdate
            );

            if (Object.keys(oldComposition).length === 0) {
                dispatch(
                    deleteAbortedNewItem({
                        product: { path: MenuPath },
                    })
                );
            }
            if (Object.keys(oldComposition).length > 0) {
                dispatch(
                    restoreItemComposition({
                        oldComposition,
                        stepPath: MenuPath,
                    })
                );
            }
        }
        if (workflow?.length === 0) {
            dispatch(setIsModification(false));
            onClose();
        } else {
            const title =
                copyWorkflow[copyWorkflow.length - 1].workflow[
                    copyWorkflow[copyWorkflow.length - 1].index
                ].title;

            const data = {
                [title]: {
                    path: [
                        ...copyWorkflow[copyWorkflow.length - 1].workflow[
                            copyWorkflow[copyWorkflow.length - 1].index
                        ].path,
                    ],
                },
            };
            if (
                !isModification &&
                !orderWorkflowItemSlice.isInternalModification
            ) {
                dispatch(deleteWorkFlowStepShopCart(data[title]));

                if (menuProduct.haveAdditionalSale) {
                    dispatch(
                        setAdditionalItems({
                            name: "",
                            listItems: [],
                            selectedItems: [],
                        })
                    );
                }
            }

            if (
                isModification &&
                orderWorkflowItemSlice.isInternalModification &&
                copyWorkflow.length <= 1
            ) {
                dispatch(setIsModification(false));
            }

            dispatch(
                removeLastWorkflow({
                    isModif:
                        isModification ||
                        orderWorkflowItemSlice.isInternalModification,
                    isCancelEditProduct:
                        Object.keys(oldComposition).length === 0,
                })
            );
            dispatch(SelectProduct({}));
        }
    };
    return (
        <StyledDiv className="d-flex justify-content-end align-items-start">
            {isNutriscoreInCompositeProductActive &&
            product.nutriScore !== undefined &&
            Object.keys(product.nutriScore).length > 0 ? (
                <div className="d-flex justify-content-center align-items-center h-100 w-30">
                    <Nutriscore
                        nutriscoreType={product?.nutriScore.label}
                        styles={styles}
                    />
                </div>
            ) : (
                <div className="d-flex justify-content-center align-items-center h-100 w-30"></div>
            )}
            {isProductInfoIconActive ? (
                <div
                    className="pt-2 d-flex align-items-start justify-content-end  h-100 w-40"
                    style={{ width: "inherit" }}
                    onClick={(e) => {
                        e.stopPropagation();
                        !product.outOfStock &&
                            handleNutritionalInformationDialogOnCloseEvent();
                    }}
                >
                    {InfoImageSrc !== "" ? (
                        <img width={45} height={45} src={InfoImageSrc} />
                    ) : (
                        <InfoIcon width={45} height={45} />
                    )}
                </div>
            ) : null}
            {isClosingButtonActive ? (
                <div
                    className={classNames(
                        "pt-1 d-flex align-items-start justify-content-end h-100 w-40",
                        {
                            "": workflowData.length > 1,
                        }
                    )}
                    style={{ width: "inherit" }}
                    onClick={() => {
                        OnClickClose();
                    }}
                >
                    {imageSrc !== "" ? (
                        <img
                            style={{
                                height: "80%",
                                width: "100%",
                                borderRadius: "100%",
                            }}
                            src={imageSrc}
                        />
                    ) : (
                        <ClosecircleIcon />
                    )}
                </div>
            ) : null}
        </StyledDiv>
    );
}
